import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid, LinearProgress, FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
} from '@material-ui/core';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import i18n from '@i18n';
import {
  useRoles,
} from '@hooks';
import {
  Alert, ButtonAdorned, Subtitle,
} from '@components/atoms';

const Edit = ({ id }) => {
  const { pages: { employees: { presupuestos: { edit: texts } } } } = i18n;
  const history = useHistory();
  const {
    getRol, rolesError, isRolesLoading, editRole,
  } = useRoles();
  const [rol, setRol] = useState({
    id: '',
    rolName: '',
    permissions: [],
  });

  const { enqueueSnackbar } = useSnackbar();

  const form = useFormik({
    initialValues: rol,
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: async () => {
      const transformRole = ({
        name: rol.rolName,
        id: rol.id,
        permissions: rol.permissions.reduce((modules, module) => {
          const permisos = module.permisos.reduce((acc, permiso) => ({
            ...acc,
            [permiso.id]: permiso.enabled,
          }), {});

          return {
            ...modules,
            [module.modulo]: permisos,
          };
        }, {}),
      });

      const updated = await editRole(transformRole);
      if (updated) {
        enqueueSnackbar(texts.success, { variant: 'success' });
        history.push('/e/roles');
      }
    },
  });

  useEffect(async () => {
    const serviceRoles = await getRol(id);
    setRol(serviceRoles);
  }, []);

  const togglePermission = (moduloId, permisoId) => {
    setRol((prev) => ({
      ...prev,
      permissions: prev.permissions.map((modulo) => (modulo.modulo === moduloId
        ? {
          ...modulo,
          permisos: modulo.permisos.map((permiso) => (permiso.id === permisoId
            ? {
              ...permiso,
              enabled: !permiso.enabled,
            }
            : permiso)),
        }
        : modulo)),
    }));
  };
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      {rolesError && <Alert>{rolesError.message}</Alert>}
      { (isRolesLoading) ? <LinearProgress /> : (
        <>
          <Grid container spacing={2}>
            {texts.subtitleData && (
            <Grid item xs={12} align="left">
              <Subtitle>{rol.rolName}</Subtitle>
            </Grid>
            )}
          </Grid>
          <Grid container spacing={2}>
            {rol.permissions.map((modulo) => (
              <Grid key={modulo.modulo} item xs={12}>
                <FormControl style={{ flexDirection: 'row' }}>
                  <FormLabel style={{ alignSelf: 'center', minWidth: 120 }}>{capitalizeFirstLetter(modulo.modulo)}</FormLabel>
                  {
                    modulo.permisos.map((permiso) => (
                      <FormGroup key={permiso.id} style={{ minWidth: 100 }}>
                        <FormControlLabel
                          control={<Checkbox name={permiso.label} checked={permiso.enabled} onChange={() => togglePermission(modulo.modulo, permiso.id)} />}
                          label={permiso.label}
                        />
                      </FormGroup>
                    ))
                  }
                </FormControl>
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <ButtonAdorned color="default" onClick={() => history.push('/e/roles')}>
                {texts.list}
              </ButtonAdorned>
            </Grid>
            <Grid item>
              <form onSubmit={form.handleSubmit}>
                <ButtonAdorned loading={isRolesLoading} disabled={isRolesLoading} type="submit">
                  {texts.save}
                </ButtonAdorned>
              </form>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

Edit.propTypes = {
  id: PropTypes.string,
};

Edit.defaultProps = {
  id: '',
};

export default Edit;
